<script lang="ts">
	export let group;
	export let value;
	/** The key to listen for */
	export let key: string = null;

	function handleKey(e: KeyboardEvent) {
		if (key && e.key === key) {
			group = value;
		}
	}

</script>

<svelte:window on:keypress={handleKey}/>

<label for="{value}" class:checked={group === value}>
	<span class="start-item">
		<slot name="start"></slot>
	</span>
	<input id="{value}" type="radio" bind:group {value}>
	<span class="label-text">
		<slot></slot>
	</span>
</label>

<style lang="scss">
	$start-item-offset: 6px;
	label {
		border: 1px solid black;
		border-radius: 12px !important;

		display: flex;
		cursor: pointer;
		margin-left: $start-item-offset;

		&.checked {
			border-width: 2px;
			.start-item {
				border-width: 2px;
				background: rgba(248, 185, 44, 1);
			}
		}

		&:focus-within {
			box-shadow: var(--btn-focus-box-shadow);
		}
	}
	input[type="radio"] {
		all: unset; /* remove default styles */
	}
	.start-item {
		border: 1px solid black;
		border-radius: 5px;
		color: black;

		font-family: 'Open Sans', sans-serif;
		font-size: 12px;
		font-weight: 600;
		//line-height: 12px;
		letter-spacing: 0;
		text-align: left;

		line-height: 1;
		margin: auto 0;
		padding: 8px;
		background-color: white;
		transform: translateX(-$start-item-offset);
	}
	.label-text {
		font-family: 'Open Sans', sans-serif;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.2rem;
		letter-spacing: 0;
		text-align: left;

		color: black;
		padding: 15px 20px 15px 5px;
	}
</style>
